if (!customElements.get("country-selector")) {
    customElements.define(
      "country-selector",
      class CountrySelector extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.button = this.querySelector(".country-selector__button");
            this.dropdown = this.querySelector(".country-selector__dropdown");

            this.button.addEventListener("click", () => {
                this.button.classList.toggle("country-selector__button--active");
                this.dropdown.classList.toggle("country-selector__dropdown--active");
            });

            window.addEventListener("click", (e) => {
                if (!this.contains(e.target) && !this.button.contains(e.target)) {
                    this.button.classList.remove("country-selector__button--active");
                    this.dropdown.classList.remove("country-selector__dropdown--active");
                }
            });
        }
  
        disconnectedCallback() {

        }
      },
    );
  }
  

//   NL,Netherlands ($),https://opposuits.com/pages/reviews
// DE,Germany ($),https://opposuits.com/pages/reviews
// US,United States ($),https://opposuits.com/pages/reviews
// GB,United Kingdom ($),https://opposuits.com/pages/reviews
// EU, Europe ($),https://opposuits.com/pages/reviews